export function invalidAssessmentError(assessmentData) {
  if (
    assessmentData.transcriptionStatus === 'failed' ||
    assessmentData.transcriptionStatus === 'unrecoverable' ||
    assessmentData.assistedGradingStatus === 'failed' ||
    assessmentData.assistedGradingStatus === 'unrecoverable'
  ) {
    return {
      transcriptionError:
        assessmentData?.formattedTranscription?.failureMessage,
      assistedGradeError:
        assessmentData?.formattedAssistedGrade?.failureMessage,
    };
  }
  return null;
}
